import React from 'react';
import image from "../../assets/stats_school-removebg-preview.png"
import { Link } from 'react-router-dom';
import bgimage from "../../assets/school-bg.png"

function SchoolMission() {
    return (
        <div className="relative bg-cover bg-center bg-no-repeat min-h-screen">
            <img src={bgimage} alt="Background" className="absolute opacity-30 inset-0 w-full h-full object-cover" />
            <div className="relative px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">

                <div className="grid gap-8 row-gap-8 lg:grid-cols-2">
                    <div className="relative w-full">
                        <img
                            className="md:max-w-lg lg:max-w-lg xl:max-w-lg max-w-full h-auto object-contain"
                            src={image}
                            alt="Descriptive Alt Text 1"
                        />
                    </div>
                    <div className="flex flex-col justify-center">
                        <div className="max-w-xl mb-6">
                            <div>
                                <p className="inline-block px-3 mb-4 text-xs font-semibold tracking-wider text-gray-100 uppercase rounded-full bg-teal-accent-400 bg-blue-500 py-2 w-fit ">
                                    Our LMS Offers you with
                                </p>
                            </div>
                            <h2 className="max-w-lg mb-6 font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none">
                                Quality education
                            </h2>
                            <p className="text-base text-gray-700 md:text-lg">
                                We strive to deliver an inclusive and engaging educational experience. Our LMS is a testament to our commitment to integrating technology with education, ensuring every student can thrive in a dynamic learning environment.
                            </p>
                        </div>
                        <Link
                            to="/"
                            aria-label=""
                            className="inline-flex items-center font-semibold transition-colors duration-200 text-deep-purple-accent-400 hover:text-deep-purple-800 bg-yellow-400 py-2 px-5 rounded-lg w-fit text-gray-600"
                        >
                            Learn more
                            <svg
                                className="inline-block w-3 ml-2"
                                fill="currentColor"
                                viewBox="0 0 12 12"
                            >
                                <path d="M9.707,5.293l-5-5A1,1,0,0,0,3.293,1.707L7.586,6,3.293,10.293a1,1,0,1,0,1.414,1.414l5-5A1,1,0,0,0,9.707,5.293Z" />
                            </svg>
                        </Link>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default SchoolMission